import http from '../http';
import { compute as defaultCompute, sample as defaultSample } from './default';
import gauge from './gauge';
import pie from './pie';
import line from './line';
import singlevalue from './singlevalue';

const generator = {
  "default": { defaultCompute, defaultSample },
  gauge,
  pie,
  singlevalue,
  line,
};

export default {
  sample: function(chartType, chartTemplate, chartSize) {
    return http(
      `src/Applications/System/ChartDesigner/samples/${chartType}${chartTemplate}.json`
    ).then((sample) => {
      const charttype = chartType.toLowerCase();
      const sampleGenerator =
        generator[charttype] &&
        generator[charttype] &&
        generator[charttype].sample;
      return {
        ...((sampleGenerator &&
          sampleGenerator(sample, chartTemplate, chartSize)) ||
          sample),
        chartType,
        chartTemplate,
        chartSize,
      };
    });
  },
  compute: function(args, vars, optionMeta, instance) {
    return generator[args.type].compute(args, vars, optionMeta, instance);
  },
};
